import styled from "styled-components";
import { screenWidth } from "~/config/dimensions";

export const Image = styled.img`
  position: absolute;
  width: ${(props) => screenWidth(props.width)}px;
  top: ${(props) => screenWidth(props.top)}px;
  left: ${(props) => screenWidth(props.left)}px;
`;
